// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const SearchFilters = t.struct({
    filterBy: t.String,
    query: t.String,
    sortBy: t.list(t.String),
    sortDirection: t.String
}, 'SearchFilters');

export const getDefaultState = () =>
    new SearchFilters({
        filterBy: '',
        query: '',
        sortBy: [],
        sortDirection: 'ASC'
    });

export default SearchFilters;



// WEBPACK FOOTER //
// ./src/shared/state/search-filters.js